export default "__VITE_ASSET__DNeNaKHn__"